import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Text from '../../../Text'
import orderStyles from '../../OrderConfirmationPage/styles.module.css'

function AboutUsPage({ title, sections, socials }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        {/* Single-<h1> rule (Audit A #1): the /about-us hero title ("Get fast
            faster with VRS®") is the page's one visible <h1>. `.h1-contents` adds
            no box so the two-line design is byte-identical. */}
        <h1 className="h1-contents"><div className={styles.title}>
          <div className={styles.titleFirstLine}><Text type="heading-1">Get fast faster</Text></div>
          <div className={styles.titleSecondLine}>
            <Text type="heading-1">with VRS</Text>
            <div className={styles.registeredSymbolWrapper}><Text type="heading-2">®</Text></div>
          </div>
        </div></h1>
        { sections.map((s, i) => <div className={styles.section} key={'section-' + i}>
          <SimpleBlockContent blocks={s.title}/>
          <SimpleBlockContent blocks={s.text}/>
        </div>
        )}
        <div className={styles.section}>
          <div className={orderStyles.socialsTitle}>
            <div className={styles.socialTitleSeparator}/>
            <div className={orderStyles.socialsTitleText}><Text type="heading-6">Follow us</Text></div>
            <div className={styles.socialTitleSeparator}/>
          </div>
          <div className={styles.socialIcons}>
            {
              socials.map(s => (
                <a className={styles.socialLink} key={s.url} href={s.url} target="_blank" rel="noreferrer" >
                  {/* task #67: s.icon is now a ResolvedImage descriptor */}
                  <img className={styles.icon} src={s.icon?.src} alt="social-icon" width={32} height={32}/>
                </a>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutUsPage
